module.exports = __webpack_public_path__ + "static/media/newTruck.5544c657.svg";